<script lang="ts" setup>
const { breadcrumbList, breadcrumbs } = useBreadcrumbs()
useHead({
  script: [{ key: 'BreadcrumbList', type: 'application/ld+json', innerHTML: breadcrumbList.value }],
})

defineProps({
  className: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <nav
    v-if="breadcrumbs"
    class="breadcrumbs"
    :class="className"
    :aria-label="$t('Breadcrumbs')"
  >
    <div class="breadcrumbs__container">
      <div class="breadcrumbs__title">
        {{ $t('You are here') }}
      </div>

      <ol class="breadcrumbs__list">
        <li class="breadcrumbs__item breadcrumbs__item-home">
          <AppLink
            to="/"
            class="breadcrumbs__link"
          >
            <!--
            <NuxtIcon
              name="icon:arrow"
              class="icon:arrow-left"
            />
            -->
            <span>Home</span>
          </AppLink>

          <span class="breadcrumbs__divider">
            <slot name="divider">
              <NuxtIcon name="icon:chevron" />
            </slot>
          </span>
        </li>

        <template
          v-for="parent in breadcrumbs.parents"
          :key="parent"
        >
          <li
            class="breadcrumbs__item"
          >
            <AppLink
              v-if="parent && parent.url"
              :to="'/' + parent.url"
              class="breadcrumbs__link"
            >
              <span>{{ parent.label }}</span>
            </AppLink>

            <span class="breadcrumbs__divider">
              <slot name="divider">
                <NuxtIcon name="icon:chevron" />
              </slot>
            </span>
          </li>
        </template>

        <li
          v-if="breadcrumbs.label"
          class="breadcrumbs__item"
        >
          <AppLink
            to=""
            aria-current="location"
            class="breadcrumbs__label"
          >
            {{ breadcrumbs.label }}
          </AppLink>
        </li>
      </ol>
    </div>
  </nav>
  <div v-else /><!-- Need for My Account where breadcrumb disapeares -->
</template>

<style>
@import url("~layers/components/App/Breadcrumbs.css");
</style>
